import { useQuery } from '@apollo/client';
import { AUTH_QUERY } from '../gql';

export function useCanUseFindPresets(): boolean {
  const { data } = useQuery(AUTH_QUERY, { fetchPolicy: 'cache-first' });
  const user = data?.viewer?.user;

  return (
    user?.role === 'admin' || data?.viewer?.premiumAccess?.isPremium === true
  );
}
